import React, { useEffect } from 'react';

/**
 * 微信登录加载页面
 * 微信扫码后会在 iframe 内跳转到此页面
 * 此页面负责将 code 通过 postMessage 发送给父页面
 */
const Loading: React.FC = () => {
  useEffect(() => {
    // 解析 URL 参数
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');

    if (code && state) {
      // 向父页面发送消息
      window.parent.postMessage({ code, state }, '*');
    }
  }, []);

  return (
    <div className="relative w-full h-screen flex flex-col bg-white">
      {/* 遮罩层 */}
      <div className="fixed inset-0 bg-white z-10"></div>
      
      {/* 加载动画容器 */}
      <div className="fixed inset-0 flex items-center justify-center z-20">
        <div className="inline-block text-center">
          {/* 三个圆点加载动画 */}
          <div className="flex items-center justify-center space-x-3">
            <span 
              className="inline-block w-3 h-3 bg-green-400 rounded-full animate-bounce"
              style={{ animationDelay: '0ms', animationDuration: '1.4s' }}
            ></span>
            <span 
              className="inline-block w-3 h-3 bg-green-400 rounded-full animate-bounce"
              style={{ animationDelay: '0.16s', animationDuration: '1.4s' }}
            ></span>
            <span 
              className="inline-block w-3 h-3 bg-green-400 rounded-full animate-bounce"
              style={{ animationDelay: '0.32s', animationDuration: '1.4s' }}
            ></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
